export function Loading({size}) {
    return (
        <span className="loader" style={{fontSize: size ? size : ""}}></span>
    )
}